import { useState } from "react";
import { Link } from "react-router-dom";
import { requestMarketplacePasswordReset } from "../api/marketplaceAuth";
import { formatApiError } from "../utils/formatApiError";

export default function MarketplaceForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await requestMarketplacePasswordReset(identifier.trim());
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Marketplace password reset request error:", err);
      }
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#fef3f2,_#f7ebe7_42%,_#eef2ff_100%)]">
      <div className="flex min-h-screen items-center justify-center px-4 py-8">
        <div className="w-full max-w-lg rounded-[28px] border border-white/70 bg-white/85 px-8 py-8 shadow-[0_20px_70px_rgba(47,53,102,0.12)] backdrop-blur">
          <div className="inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-rose-600">
            Ellyanna Boothshare
          </div>
          <h1 className="mt-5 text-3xl font-semibold leading-tight text-slate-900">
            Reset your Ellyanna Boothshare password
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            Enter your email or username. If an account matches, we&apos;ll email a
            reset link for your shared Ellyanna Boothshare sign-in. No Salon ID is required.
          </p>

          {submitted ? (
            <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
              If an account matches, we emailed a password reset link.
            </div>
          ) : null}

          {error ? (
            <div className="mt-5 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {error}
            </div>
          ) : null}

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label
                htmlFor="marketplace-forgot-password-identifier"
                className="block text-xs font-medium uppercase tracking-wide text-slate-700"
              >
                Email or username
              </label>
              <input
                id="marketplace-forgot-password-identifier"
                type="text"
                required
                value={identifier}
                onChange={(event) => setIdentifier(event.target.value)}
                className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm focus:border-rose-400 focus:outline-none focus:ring-2 focus:ring-rose-200"
                placeholder="Enter email or username"
              />
            </div>

            <div className="flex items-center gap-3">
              <button
                type="submit"
                disabled={submitting}
                className="rounded-xl bg-rose-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-rose-600 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {submitting ? "Sending..." : "Email reset link"}
              </button>
              <Link
                to="/login"
                className="text-sm font-medium text-slate-600 hover:text-slate-900"
              >
                Back to sign in
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
